import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ language }: ReduxState): string => language;
